<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page :title="title">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
       <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'Senarai Permohonan Penilaian Daya Biak'" >
         <w-flex justify-end class="mt2">
           <w-tooltip md top color="white" bg-color="primary">
             <template #activator="{ on }">
               <w-button 
                 round 
                 shadow 
                 class="primary--bg ml1" 
                 @click="cetak(id)" 
                 v-on="on"
                 style="transition: all 0.3s ease;"
               >
                 <w-icon md class="mr1" style="transform: scale(1.1);">fal fa-print</w-icon>
                 <span class="ml1" style="font-weight: 500;">Cetak</span>
               </w-button>
             </template>
             Cetak Borang
           </w-tooltip>
         </w-flex>
           &nbsp;
            <div class="w-table-wrap" style="max-height: 400px;">
            <div class="table-profil-scrol">
              <table class="w-table" color="light" >
                <thead>
                  <tr>
                    <th class="w-table__header  text-center" width="1%">BIL</th>
                    <th class="w-table__header  text-center">NO PENDAFTARAN </th>
                    <th class="w-table__header  text-center">ID | NAMA TERNAKAN</th>
                    <th class="w-table__header  text-center">JENIS TERNAK</th>
                    <th class="w-table__header  text-center">TARIKH PEMERIKSAAN</th>
                    <th class="w-table__header  text-center">TARIKH LAPORAN</th>
                    <th class="w-table__header  text-center">BERAT BADAN</th> 
                    <th class="w-table__header  text-center">SKOR BADAN</th> 
                    <th class="w-table__header  text-center">TANDA KLINIKAL PENYAKIT</th> 
                    <th class="w-table__header  text-center">STATUS PEMERIKSAAN</th>   
                    <th class="w-table__header  text-center">TINDAKAN</th>      
                  </tr>
                </thead>
                <tbody>
                  <template v-if="sejarah.length == 0">
                    <tr class="w-table__row" >
                      <td class="w-table__cell text-left" colspan="9"> Tiada Data.</td>
                    </tr>
                  </template>
                  <template v-for="(data, ind) in sejarah">
                    <tr class="w-table__row" >
                      
                      <td class="w-table__cell text-center" >{{ind+1}}</td>
                      <td class="w-table__cell text-center" >{{data.ternakan_kode}}</td>
                      <td class="w-table__cell text-center" style="text-transform: uppercase;">{{data.id_ternakan}} | {{data.ternakan_nama}}</td>
                      <td class="w-table__cell text-center" >{{data.ternakan}}</td>
                      <td class="w-table__cell text-center" >{{data.tarikh_pemeriksa}}</td>
                      <td class="w-table__cell text-center" >{{data.tarikh_laporan}}</td>
                      <td class="w-table__cell text-right" >{{data.berat_badan}}</td>
                      <td class="w-table__cell text-right" >{{data.skor}}</td>
                      <td class="w-table__cell text-center" >{{data.tanda_klinikan}}</td>
                      <td class="w-table__cell text-center" >{{data.status_pemeriksa}}</td>
                      <td class="w-table__cell text-center" >
                        <w-tooltip top color="white" bg-color="black" >
                            <template #activator="{ on }">
                               <w-button  bg-color="primary" v-on="on" :route="$route('art.semakan.penilaian.bse_show',data.id)" class="be fs-2"><div style="width: 8px"></div>
                               <w-icon md class="mr2">fal fa-eye</w-icon>
                               </w-button>
                             </template>
                             Papar
                           </w-tooltip>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              </div>
            </div>
        </w-card>
        <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
     </div>
  </div>
      </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    id : [Object],
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.semakan.sejarah',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Perkhidmatan Daya Biak', route: '/pdbf' },
        { label: 'Sejarah', route: '/pdbf/penilaian' },
      ],
      title : 'Pdbf Penilaian',
      form : this.d_form,
      
      
      pencarian: {
         no_kes_id: '',
         ternakan_id: '',
      },
      no_kes_id: [],
      ternakan_id:[],
      sejarah: [],
      
      
    }
  },
  methods: {
       

    getData(){

      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'pdbf/sejarah/'+this.id, {}).then(res => {
          this.sejarah = res
          this.load = this.load + 1
        })
      }
      
    },

    cetak(id){
        // this.$inertia.visit(route("kursus.kursus.peserta.sijil_peserta", dt.peseta_user_id) +"?kursus_id="+dt.id,);
        window.open( window.route('art.penilaian.bse.cetak', id), '_blank');
    },

    tutup(){
         this.$inertia.visit(window.route('art.semakan.index'));
       },
  
  },

  watch: {

  },
  mounted() {
   if(this.data.jantina==1)
    {
      this.title = 'Rekod Maklumat Penilaian Daya Biak'
    }
    else
    {
      this.title = 'Rekod Maklumat Penilaian Daya Biak'
    }
   this.getData()
   // this.getPremis();
   // this.getPenilai();
   // this.getPremisCarian();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
